const t=(t,e="")=>{let n=t;return e.length<n?e:(3===n&&(n+=3),`${e.substring(0,n-3)}...`)};export{t as truncate};
